import { render, staticRenderFns } from "./TemplateTestModal.vue?vue&type=template&id=13d57274&scoped=true&"
import script from "./TemplateTestModal.vue?vue&type=script&lang=js&"
export * from "./TemplateTestModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTestModal.vue?vue&type=style&index=0&id=13d57274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d57274",
  null
  
)

export default component.exports